module.exports = __webpack_public_path__ + "media/Video 88.16709f3c.mp4";